import { Fragment } from "react";
import { useNavigate } from "react-router-dom";

export function DashboardView() {
    const navigate = useNavigate()
    // navigate('/dashboard')

    return <Fragment>
        Dashboard
    </Fragment>
}